import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { RiCloseLine } from 'react-icons/ri';

import KeyboardShortcutsGuide from './keyboardShortcutsGuide';

const KeyboardShortcutsModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className="respark-product-docs respark-product-docs--keyboard"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
    >
      <div className="respark-product-docs__backdrop" onClick={onClose} aria-hidden />
      <div className="respark-product-docs__shell">
        <header className="respark-product-docs__header">
          <div className="respark-product-docs__brand">
            <span className="respark-product-docs__brand-label">Respark Help</span>
            <span className="respark-product-docs__brand-sep">/</span>
            <span className="respark-product-docs__brand-page">Keyboard shortcuts</span>
          </div>
          <button
            type="button"
            className="respark-product-docs__close"
            aria-label="Close keyboard shortcuts"
            onClick={onClose}
          >
            <RiCloseLine size={22} aria-hidden />
          </button>
        </header>

        <div className="respark-keyboard-shortcuts__body">
          <KeyboardShortcutsGuide layout="modal" />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default KeyboardShortcutsModal;
